<template>
    <div id="generator_contentStyle">
        <div class="generator_title">{{ templateItem.paramName }}</div>
        <div class="generator_contentStyle " v-if="ifMany">
            <div class="cursor_1 generator_contentStyle1" :class="item.select ? 'tech-bg-info' : ''"
                @click="selectStyle(i)" v-for="(item, i) in styleList" :key="i">
                {{ item.name }}
            </div>
        </div>
        <div class="generator_contentStyle" v-else>
            <div  class="cursor_1 generator_contentStyle1" :class="styleIndex == i ? 'tech-bg-info' : ''"
                @click="selectStyle(i)" v-for="(item, i) in styleList" :key="i">
                {{ item.name }}
            </div>
        </div>
        <div>
            <el-input v-model="customize" @blur="getCustomize1" @input="getCustomize2" placeholder="自定义" show-word-limit :maxlength="maxlength"></el-input>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        templateItem: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            ifMany: false, //单选多选
            styleList:[],
            styleIndex: null, //单选下标
            customize: '',//自定义文字
            maxlength: this.templateItem.paramType == 'select' ? 300 : 10000, //最大输入字数
        }
    },
    created() {
        this.ifMany = this.templateItem.paramName.includes('可多选')
        this.styleList = []
        this.styleList = this.templateItem.placeholder.split(',').map(item => {
            if (this.ifMany) {
                return {
                    name: item,
                    select: false
                };
            }
            return {
                name: item
            };
        });
    },
    methods: {
        selectStyle(i) {
            if (this.ifMany) {
                this.styleList[i].select = !this.styleList[i].select
                let styleItem = this.styleList.filter(item => item.select).map(item => item.name);
                this.styleString = styleItem.join(',');
                if(this.customize){
                    this.styleString += ',' + this.customize
                }
            } else {
                this.styleIndex = i
                this.customize = ''
                this.styleString = this.styleList[i].name
            }
            this.$emit('getStyle', this.templateItem, this.styleString)
        },
        getCustomize1() {
            if (this.ifMany) {
                this.styleString += ',' + this.customize
            }
            this.$emit('getStyle', this.templateItem, this.styleString)
        },
        getCustomize2() {
            if (!this.ifMany) {
                this.styleIndex = null
                this.styleString = this.customize
            }
            this.$emit('getStyle', this.templateItem, this.styleString)
        }
    }
}
</script>

<style>
#generator_contentStyle {
    width: 100%;
    margin-bottom: 15px;
}

.generator_contentStyle {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.generator_contentStyle1 {
    width: calc((100% - 30px) / 3);
    font-size: 15px;
    color: #666666;
    background-color: #F5F5F5;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
}

.generator_contentStyle1:nth-child(3n) {
    margin-right: 0;
}

.generator_contentStyle2 {
    background-color: var(--tech-primary);
    color: #FFFFFF;
}
</style>